WiseMetering.Collection.Devices = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Device,
    url: '/devices',

    wiseBoxes: function(site_id) {
        let conditions = { wise_box: true };
        if (site_id) {
            conditions.site_id = site_id;
        }

        return new WiseMetering.Collection.Devices(this.where(conditions));
    }
});
